import axios from "axios";
import { resetStore, store } from "../store";
import { showToast } from "../Components/ToastNotification";
import { logoutThunk, logoutUser } from "../slices/thunks";

// default
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const token = JSON.parse(localStorage.getItem("authUser"))
  ? JSON.parse(localStorage.getItem("authUser")).token
  : "";
// console.log("token", token);
if (token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    const status = error.response?.status;
    const messageFromServer = error.response?.data?.message;
    const errorData = error.response?.data;
    const token = localStorage.getItem("authUser");
    if (status === 401) {
      // Wait for logoutThunk to complete before doing further actions
      store
        .dispatch(logoutThunk({ token }))
        .unwrap()
        .then(() => {
          // Logout API call successful
          store.dispatch(logoutUser());
          localStorage.setItem("autoLogout", "true");
          window.location.href = "/login";
        })
        .catch((logoutError) => {
          // If the logout API call fails, you might still want to force logout
          console.error("Logout API failed", logoutError);
          store.dispatch(logoutUser());
          localStorage.setItem("autoLogout", "true");
          window.location.href = "/login";
        });
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = messageFromServer || "Internal Server Error";
        break;
      // case 401:
      //   message = "Invalid credentials";
      //   break;
      // case 404:
      //   message = "Sorry! the data you are looking for could not be found";
      //   break;
      default:
        message = error?.response?.data?.message;
    }
    const errorObject = {
      message: message, // For backward compatibility
      fullError: errorData, // Full error data for new code
      // Legacy support: make it behave like a string when used as string
      toString: () => message,
    };
    return Promise.reject(errorObject);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  getAuth = (url, token) => {
    // console.log("token in getAuth",token)
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          // console.log(error);
          if (error?.message == "Unauthenticated.") {
            showToast("Session Expired. Please login again.", "error");
            logout();
          }
          reject(error);
        });
    });
  };

  // get auth with params
  getAuthParam = (url, params, token, isBlob = false) => {
    let queryParams = "";
    if (params) {
      queryParams = "?" + new URLSearchParams(params).toString();
    }

    const options = {
      method: "GET",
      url: `${url}${queryParams}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "application/json",
      },
      responseType: isBlob ? "blob" : "json",
    };

    return axios.request(options);
  };

  // get auth without params
  getAuthWithoutParam = (url, token) => {
    const options = {
      method: "GET",
      url: `${url}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "application/json",
      },
      responseType: "json",
    };

    return axios.request(options);
  };

  // post auth without params
  postAuthWithoutParam = (url, token) => {
    const options = {
      method: "POST",
      url: `${url}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "application/json",
      },
      responseType: "json",
    };

    return axios.request(options);
  };
  // post auth with params
  postAuthParam = (url, params, token) => {
    let queryParams = "";
    if (params) {
      queryParams = "?" + new URLSearchParams(params).toString();
    }

    const options = {
      method: "POST",
      url: `${url}${queryParams}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "application/json",
      },
    };

    return axios.request(options);
  };

  // storeAuth
  storeAuth = (url, body, token) => {
    let dataToSend;

    // Check if 'body' is already a FormData instance.
    if (body instanceof FormData) {
      dataToSend = body;
    } else {
      // If it's a plain object, convert it to FormData.
      dataToSend = new FormData();
      for (const key in body) {
        if (Object.prototype.hasOwnProperty.call(body, key)) {
          dataToSend.append(key, body[key]);
        }
      }
    }

    const options = {
      method: "POST",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: dataToSend,
    };

    return axios.request(options);
  };

  // post auth with params
  postAuthParam = (url, params, token) => {
  
    let queryParams = '';
    if (params) {
      queryParams = '?' + new URLSearchParams(params).toString();
    }

    const options = {
      method: 'POST',
      url: `${url}${queryParams}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'content-type': 'application/json',
      },
      responseType:'json', 
    };

    return axios.request(options);
  };

  /**
   * post given data to url
   */
  // postLogoutAuth
  postLogOutAuth = (url, token) => {
    const options = {
      method: "POST",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    return axios.request(options);
  };

  // post auth
  postAuth = (url, body, token) => {
    const options = {
      method: "POST",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },

      data: new URLSearchParams(body),
    };
    return axios.request(options);
  };

  //post auth to append image in body
  postAuthAdd = (url, body, token) => {
    const options = {
      method: "POST",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },

      data: body,
    };
    return axios.request(options);
  };

  create = (url, data) => {
    // console.log("data checking", data);
    return axios.post(url, data);
  };
  createAuth = (url, data, token) => {
    // const tokenn = JSON.parse(sessionStorage.getItem("authUser")).token
    // console.log("create auth token", url, data, token);
    // for(let key in data){
    //   // console.log(key, data[key])
    //   if(key==="checkPoints" || key=="childParts" || key == "shifts" || key=="cost" || key=="type" || key== "insurance" || key=="maintenance" || key=="warranty" || key=="item" || key=="location" || key=="inventory_items" || key=="check_points" || key=="child_parts" || key =="materials" || key=="items"){
    //     if(typeof(data[key])!=typeof(""))
    //     data[key]=JSON.stringify(data[key])
    //   }
    // }
    return axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          // 'Content-Type': 'multipart/form-data',
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log("res", res);
        return res;
      })
      .catch((err) => {
        // console.log("err", err);
        if (err?.message == "Unauthenticated.") {
          showToast("Session Expired. Please login again.", "error");
          logout();
        }
        return err;
      });
  };
  createAuthFile = (url, data, token) => {
    // console.log("in helper",data);
    const formData = new FormData();

    for (let key in data) {
      // console.log("key, data[key]",key, data[key])
      formData.append(key, data[key]);
    }

    // console.log("data & formData", data, formData);
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            Accept: "application/json",

            // 'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.code == "201" || res.code == "200") {
            resolve(res);
          } else if (res.code == "400") {
            // console.log("400");
            reject(res);
          }
          // return res
        })
        .catch((err) => {
          // console.log(err);
          if (err?.message == "Unauthenticated.") {
            showToast("Session Expired. Please login again.", "error");

            logout();
          }
          reject(err);
          // return err
        });
    });
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };
  updateAuth = (url, data, token) => {
    for (let key in data) {
      // console.log(key, data[key])
      if (
        key === "checkPoints" ||
        key == "childParts" ||
        key == "shifts" ||
        key == "cost" ||
        key == "insurance" ||
        key == "maintenance" ||
        key == "warranty" ||
        key == "item" ||
        key == "location" ||
        key == "inventory_items" ||
        key == "materials"
      ) {
        if (typeof data[key] != typeof "")
          data[key] = JSON.stringify(data[key]);
      }
    }
    return axios.patch(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  };

  updateAuthFile = (url, data, token) => {
    // console.log("Data before appending to FormData:", data); // Debugging

    const formData = new FormData();

    for (let key in data) {
      // console.log("key, data[key]",key, data[key])
      formData.append(key, data[key]);
    }
    // console.log("formData",...formData)
    formData.append("_method", "PATCH");
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.code == "201" || res.code == "200") {
            resolve(res);
          } else if (res.code == "400") {
            // console.log("400");
            reject(res);
          }
          // return res
        })
        .catch((err) => {
          // console.log(err);
          if (err?.message == "Unauthenticated.") {
            showToast("Session Expired. Please login again.", "error");

            logout();
          }
          reject(err);
          // return err
        });
    });
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, data, token) => {
    return axios.delete(url, {
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  };
}

const logout = () => {
  sessionStorage.removeItem("authUser");
  localStorage.removeItem("authUser");
  localStorage.removeItem("persist:root");
  sessionStorage.removeItem("persist:root");
  sessionStorage.removeItem("welcomeModalShown");
  resetStore();
  // console.log("here in logout");

  // setTimeout(() => {
  //   window.location.href = "/auth";
  // }, 2000);
};

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
